import { BaseWebComponentView } from '../../../framework/BaseWebComponentView';
import { htmlEncode } from '../../../utils/escape.utils';
import { LINK_CLICKED } from '../types';
import { ColumnKeys } from '../../responseGrid/types';

export class ResponsePanelItemView extends BaseWebComponentView {
  getDomElements() {
    this.dom.$wrapper = this.shadow.querySelector('.wrapper');
    this.dom.$actionCategoryName = this.shadow.querySelector('#actionCategoryName');
    this.dom.$actions = this.shadow.querySelector('#actions');
    this.dom.$detailsLink = this.shadow.querySelector('#detailsLink');
  }

  buildView(data: any) {
    if (!data) {
      this.dom.$wrapper.innerHTML = '';
      return;
    }
    if (data.response.actionCategoryName) {
      this.dom.$actionCategoryName.classList.add('show-chategory');
      this.dom.$actionCategoryName.innerHTML = htmlEncode(
        this.dependencies.translateFn(data.response.actionCategoryName)
      );
    }

    let actions = ``;
    for (const action of data.response.actions) {
      let numberOfActions = action.numberOfActions;
      if (numberOfActions > 99) {
        numberOfActions = '99+';
      }
      actions += `<div class="action-container">
                    <gz-link
                      class="title-link"
                      showicon=false
                      type="quiet"
                      fontsize="16"
                      color="primary"
                      href=""
                      data-category="${data.response.category}"
                      data-view="${data.response.view}"
                      data-actionType="${action.actionType}"
                    >
                     ${numberOfActions}
                    </gz-link>
                    <gz-title fontweight="400" fontsize="12">${action.actionName}</gz-title>
                  </div>`;
    }
    this.dom.$actions.innerHTML = actions;

    this.dom.$detailsLink.addEventListener('click', function () {
      const filters: Array<{}> = [];
      const category = data.response.category;

      if (category) {
        filters.push({
          [ColumnKeys.TYPE]: { in: [category] },
        });
      }

      this.dispatchEvent(
        new CustomEvent(LINK_CLICKED, {
          bubbles: true,
          composed: true,
          detail: {
            view: data.response.view,
            filters,
          },
        })
      );
    });

    const gzLinks = this.dom.$actions.getElementsByTagName('gz-link');
    for (const gzLink of gzLinks) {
      gzLink.showIcon = false;
      gzLink.addEventListener('click', () => {
        const filters: Array<{}> = [];
        const category = parseInt(gzLink.getAttribute('data-category'), 10);
        const type = parseInt(gzLink.getAttribute('data-actionType'), 10);

        if (category) {
          filters.push({
            [ColumnKeys.TYPE]: { in: [category] },
          });
        }

        if (type) {
          filters.push({
            [ColumnKeys.ACTION]: { in: [type] },
          });
        }

        gzLink.dispatchEvent(
          new CustomEvent(LINK_CLICKED, {
            bubbles: true,
            composed: true,
            detail: {
              view: gzLink.getAttribute('data-view'),
              filters,
            },
          })
        );
      });
    }

    this.dom.$detailsLink.innerHTML = htmlEncode(this.dependencies.translateFn('view details'));
    this.dom.$detailsLink.showIcon = false;
  }
}
